import { useMemo } from 'react'

import styled from 'styled-components'

import { Hint } from './Hint'

interface Props {
  prefix?: string
  date: string | null
  renderDataWarning?: (date: Date) => boolean
}

export function DataFromDate({ prefix = '', date, renderDataWarning }: Props) {
  const [value, localeString] = useMemo(() => {
    if (!date) {
      return [null, null]
    }

    const value = new Date(date)
    return [value, value.toLocaleDateString(window.navigator.language)]
  }, [date])

  if (!value) {
    return null
  }

  const shouldRenderDataWarning = renderDataWarning?.(value) ?? false

  return (
    <Container>
      {`${prefix}${prefix ? ' ' : ''}${localeString}`}

      {shouldRenderDataWarning && (
        <Hint
          size="small"
          hint="Data may be available before this date, but in an older format. For more information please talk with your sales representative"
          colour="attention"
        />
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`
